import {
  getOrderHead,
  getOrderItems,
  getOrderList
} from "@/modules/firestore_repo";
import {
  getServerDate,
  loadOrderItems,
  loadOrderList
} from "@/modules/functions_repo";

const cacheDurationMs = 300000; //5 minutes caching time

function filterByStatus(orderList, filterStatus) {
  return orderList.filter(
    h =>
      (filterStatus.includes(h.deliveryStatus) && h.rejectionStatus !== "C") ||
      (filterStatus.includes("X") && h.rejectionStatus === "C")
  );
}

const state = {
  alert: null,
  filterDays: 30,
  filterItemStatus: [],
  filterStatus: [],
  isLoadingHead: true,
  isLoadingItems: true,
  isLoadingList: true,
  orderHead: null,
  orderItems: [],
  orderList: []
};

const getters = {
  getOrderHead: state => {
    return state.orderHead;
  },
  getOrderItems: state => {
    return state.filterItemStatus.length > 0
      ? filterByStatus(state.orderItems, state.filterItemStatus)
      : state.orderItems;
  },
  getOrderList: state => {
    return state.filterStatus.length > 0
      ? filterByStatus(state.orderList, state.filterStatus)
      : state.orderList;
  },
  hasOrders: state => {
    return (
      !!state.orderList &&
      Array.isArray(state.orderList) &&
      state.orderList.length > 0
    );
  }
};

const actions = {
  fetchOrderHead: async ({ commit, rootGetters }, { orderNo }) => {
    console.assert(orderNo, "orderNo must not be falsy");
    const customerId = rootGetters["customer/getCustomerId"];
    commit("setIsLoadingHead", true);
    try {
      const data = await getOrderHead(customerId, orderNo);
      commit("setOrderHead", data);
    } catch (error) {
      commit("setAlert", { message: error.message || error, type: "error" });
    }
    commit("setIsLoadingHead", false);
  },
  fetchOrderItems: async ({ commit, rootGetters }, { orderNo }) => {
    console.assert(orderNo, "orderNo must not be falsy");
    const customerId = rootGetters["customer/getCustomerId"];
    commit("setIsLoadingItems", true);
    try {
      const serverDate = await getServerDate();
      let items = await getOrderItems(
        customerId,
        orderNo,
        Math.abs(serverDate - cacheDurationMs)
      );
      if (!(items instanceof Array) || items.length == 0) {
        await loadOrderItems(customerId, orderNo);
        items = await getOrderItems(
          customerId,
          orderNo,
          Math.abs(serverDate - cacheDurationMs)
        );
      }
      console.assert(items instanceof Array, "items must be an Array");
      commit("setOrderItems", items);
    } catch (error) {
      commit("setAlert", { message: error.message || error, type: "error" });
    }
    commit("setIsLoadingItems", false);
  },
  fetchOrderList: async ({ commit, rootGetters, state }) => {
    const customerId = rootGetters["customer/getCustomerId"];
    commit("setIsLoadingList", true);
    try {
      const serverDate = await getServerDate();
      let orderList = await getOrderList(
        customerId,
        Math.abs(serverDate - cacheDurationMs),
        state.filterDays
      );
      if (!(orderList instanceof Array) || orderList.length == 0) {
        await loadOrderList(customerId, state.filterDays);
        orderList = await getOrderList(
          customerId,
          Math.abs(serverDate - cacheDurationMs),
          state.filterDays
        );
      }
      console.assert(orderList instanceof Array, "orderList must be an Array");
      commit("setOrderList", { orderList });
    } catch (error) {
      commit("setAlert", { message: error.message || error, type: "error" });
    }
    commit("setIsLoadingList", false);
  }
};

const mutations = {
  orderStatusReset(state) {
    state.filterDays = 30;
    state.filterStatus = [];
    state.filterItemStatus = [];
    state.orderHead = null;
    state.orderItems = [];
    state.orderList = [];
  },
  setIsLoadingHead(state, value) {
    state.isLoadingHead = value;
  },
  setIsLoadingItems(state, value) {
    state.isLoadingItems = value;
  },
  setIsLoadingList(state, value) {
    state.isLoadingList = value;
  },
  setAlert: (state, value) => {
    state.alert = value;
  },
  setFilterDays: (state, { filterDays }) => {
    const days = Number.parseInt(filterDays, 10);
    if (days) {
      state.filterDays = days;
    }
  },
  setFilterItemStatus: (state, { filterItemStatus }) => {
    if (!!filterItemStatus && Array.isArray(filterItemStatus)) {
      state.filterItemStatus = filterItemStatus;
    }
  },
  setFilterStatus: (state, { filterStatus }) => {
    if (!!filterStatus && Array.isArray(filterStatus)) {
      state.filterStatus = filterStatus;
    }
  },
  setOrderHead: (state, data) => {
    state.orderHead = data;
  },
  setOrderItems: (state, data) => {
    state.orderItems = data;
  },
  setOrderList: (state, { orderList }) => {
    state.orderList = orderList;
  }
};

export default {
  actions,
  getters,
  mutations,
  state
};
